<template>
  <div class="team-goal-page">
    <!--
    <div class="team-goal-page__header">
      <el-menu
        router
        :default-active="activeIndex"
        mode="horizontal"
        @select="onHandleSelect"
        active-text-color="#17abe3"
        class="subpage-header-menu">
        <el-menu-item index="1" :route="'/goal/'+$route.params.goalId+'/dashboard'">
          <div class="subpage-header-menu-block">
            <el-badge value="">
              <span class="subpage-header-menu-text">Goal</span>
            </el-badge>
          </div>
        </el-menu-item>
        <el-menu-item index="2" :route="'/goal/'+$route.params.goalId+'/kanban'">
          <div class="subpage-header-menu-block">
              <span class="subpage-header-menu-text">Tasks</span>
          </div>
        </el-menu-item>
        <el-menu-item index="3" :route="'/goal/'+$route.params.goalId+'/budget'" disabled>
          <div class="subpage-header-menu-block">
            <el-badge value="Pro">
              <span class="subpage-header-menu-text">Budget</span>
            </el-badge>
          </div>
        </el-menu-item>
        <el-menu-item index="4" :route="'/goal/'+$route.params.goalId+'/timeline'">
          <div class="subpage-header-menu-block">
            <el-badge value="Pro">
              <span class="subpage-header-menu-text">Timeline</span>
            </el-badge>
          </div>
        </el-menu-item>
        <el-menu-item index="5" :route="'/goal/'+$route.params.goalId+'/reports'">
          <div class="subpage-header-menu-block">
            <el-badge value="Pro">
              <span class="subpage-header-menu-text">Reports</span>
            </el-badge>
          </div>
        </el-menu-item>
        <el-menu-item index="6" :route="'/goal/'+$route.params.goalId+'/settings'">
          <div class="subpage-header-menu-block">
            <span class="subpage-header-menu-text">
              <font-awesome-icon icon="wrench" />
              Settings
            </span>
          </div>
        </el-menu-item>
      </el-menu>
    </div>
    -->

    <!-- show header here? -->

    <div class="team-goal-page__main goal-page-background"
      :style="{ 'background-image': 'url(\'' + goal_meta.picture + '\')'}">
      <template v-if="goal_meta.$ready">
        <!-- HACK: -->
        <GoalHeader v-if="show_goal_header_simple" :goal-id="goal_id" :show-filter="false" />

        <!-- <Dashboard :goal-id="goal_id" :key="goal_id" /> -->
        <router-view />

        <!--
        <aside class="task-container" v-if="show_task">
          <TaskDetails :key="key" />
        </aside>
        -->

      </template>
      <template v-else>
        Loading...
      </template>
    </div>
  </div>
</template>

<script>
// import TaskDetails from '@/components/TaskPage/TaskDetails'
// import Dashboard from '@/components/GoalPage/Dashboard'
import GoalHeader from '@/components/GoalPage/GoalHeader'
import { parseTpl } from '@/generic_api/lib/generic_store/template/utils'

export default {
  name: "TeamGoalPage",
  data: () => ({
  }),
  computed: {
    goal_id() {
      return this.$route.params.goalId;
    },
    goal_meta() {
      return this.$models.goalMeta.getNode( this.goal_id );
    },
    show_goal_header_simple() {
      return this.$route.name === 'settings' || this.$route.name === 'taskpage';
    },
    activeIndex() {
      switch ( this.$route.path.split('/').pop() ) {
        case 'dashboard': return '1'
        case 'kanban':    return '2'
        case 'budget':    return '3'
        case 'timeline':  return '4'
        case 'reports':   return '5'
        case 'settings':  return '6'
        case 'taskpage':  return '7';
      }
      return null;
    },
    show_task() {
      return !!this.$route.meta.showTask;
    },
    key() {
      if ( this.$route.meta.cacheKey !== undefined ) {
        let cacheKey = parseTpl( this.$route.meta.cacheKey, this.$route.params );
        console.log('[layout:default] found cacheKey', cacheKey)
        return cacheKey;
      }
      return this.$route.fullPath
    },
  },
  methods: {
    onHandleSelect(key, keyPath) {
    }
  },
  components: {
    // Dashboard,
    GoalHeader,
    // TaskDetails,
  }
};
</script>

<style>
.team-goal-page {
  height: 100%;
}
.team-goal-page__main {
  height: 100%;
}
.goal-page-background {
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
